import React from "react";
import { Typography, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import { NavigationStepperProps } from "./types";
import { StepperContainer, StepItem, StepCircle, StepConnector } from "./style";

const NavigationStepperCst: React.FC<NavigationStepperProps> = ({
  steps,
  activeStep,
  onStepChange,
  allowBackNavigation = false,
  allowForwardNavigation = false,
}) => {
  const theme = useTheme();

  const getStepState = (index: number): "active" | "completed" | "pending" => {
    if (index === activeStep) return "active";
    if (index < activeStep) return "completed";
    return "pending";
  };

  const isStepClickable = (index: number): boolean => {
    if (!onStepChange) return false;
    if (index === activeStep) return false;
    if (index < activeStep) return allowBackNavigation;
    return allowForwardNavigation;
  };

  const handleStepClick = (index: number) => {
    if (!isStepClickable(index)) return;
    onStepChange?.(index);
    console.log("Step clicked:", index);
  };

  return (
    <StepperContainer>
      {steps.map((step, index) => {
        const state = getStepState(index);
        const clickable = isStepClickable(index);
        const isActive = state === "active";

        return (
          <React.Fragment key={step.key}>
            <StepItem
              clickable={clickable}
              onClick={() => handleStepClick(index)}
            >
              <StepCircle state={state}>
                {state === "completed" && <Check size={12} strokeWidth={3} />}
              </StepCircle>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: isActive ? 700 : 500,
                  lineHeight: 1.25,
                  color: isActive
                    ? theme.palette.primary.main
                    : theme.palette.text.primary,
                  whiteSpace: "pre-line",
                  [theme.breakpoints.down("md")]: {
                    display: isActive ? "block" : "none",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                {step.label}
              </Typography>
            </StepItem>
            {index < steps.length - 1 && <StepConnector />}
          </React.Fragment>
        );
      })}
    </StepperContainer>
  );
};

export default NavigationStepperCst;
